// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundProjectionScreenOutlinedSvg from "@ant-design/icons-svg/es/asn/FundProjectionScreenOutlined";
import AntdIcon from '../components/AntdIcon';

var FundProjectionScreenOutlined = function FundProjectionScreenOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundProjectionScreenOutlinedSvg
  }));
};

FundProjectionScreenOutlined.displayName = 'FundProjectionScreenOutlined';
export default React.forwardRef(FundProjectionScreenOutlined);